import { Observable, of } from 'rxjs';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { PagedListLoader } from './paged-list.loader';
import { PagedListModel } from '../models/paged-list-model';
import { Injectable } from '@angular/core';

@Injectable()
export class PagedListBrowserLoader extends PagedListLoader {
  constructor(private readonly transferState: TransferState) {
    super();
  }

  public load<T, TPagedListModel extends PagedListModel<T>>(key: string, getPaged: () => Observable<TPagedListModel>): Observable<TPagedListModel> {
    if (!key) {
      throw 'a key is required.';
    }

    const stateKey = makeStateKey<TPagedListModel>(key);

    // If data was stored in the state by server, do not call API again and return the cached value
    if (this.transferState.hasKey(stateKey)) {
      const result = this.transferState.get<TPagedListModel>(stateKey, {} as TPagedListModel);

      // Remove state so the next time data will be fetched from the API in the browser
      this.transferState.remove(stateKey);

      return of(result);
    }
    

    // Return data from API
    return getPaged();
  }
}
